<template>
    <div class="box-shadow box-shadow--big">
        <div class="helper__wrapper">
            <h6 class="mb-3">{{ $t('SPECIFY_CHANGE_SIZE') }}</h6>

            <div class="flex-row flex-center">
                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="3MM"
                        @change="updateSize(false)"
                        name="right-breast-changes"
                        v-model="s3q2_1_sizeVal"
                    />
                    <span class="input-container"
                        >{{ $t('LIKE_PEPPER_SEED') }}<br />{{ $t('AROUND_VALUE_MM', { value: 3 }) }}</span
                    >
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="6MM"
                        @change="updateSize(false)"
                        name="right-breast-changes"
                        v-model="s3q2_1_sizeVal"
                    />
                    <span class="input-container"
                        >{{ $t('LIKE_PEA_SEED') }}<br />{{ $t('AROUND_VALUE_MM', { value: 6 }) }}</span
                    >
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="12MM"
                        @change="updateSize(false)"
                        name="right-breast-changes"
                        v-model="s3q2_1_sizeVal"
                    />
                    <span class="input-container"
                        >{{ $t('LIKE_NUT') }}<br />{{ $t('AROUND_VALUE_MM', { value: 12 }) }}</span
                    >
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="INNA"
                        @change="updateSize(true)"
                        name="right-breast-changes"
                        v-model="s3q2_1_sizeVal"
                    />
                    <span class="input-container">{{ $t('OTHER_CHANGE') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label">
                    <input
                        v-if="showValueInput"
                        :placeholder="$t('INSERT_SIZE')"
                        type="text"
                        style="margin-left: auto; margin-right: 5px; width: 170px"
                        class="el-input__inner el-input__inner--small"
                        v-model="s3q2_1_sizeDescription"
                        @change="updateDescription"
                    />
                </label>
            </div>

            <h5 class="mb-3">{{ $t('CLICK_ON_THE_PICTURE') }}</h5>

            <div class="select-img-container right-breast" :style="{ height: '189px', width: canvasWidth }">
                <canvas
                    id="rightBreast"
                    class="canvas-cursor"
                    width="175"
                    height="189px"
                    @click="updateCanvas"
                ></canvas>
            </div>
        </div>
    </div>
</template>

<script>
import { browserIsIE11 } from './../../../../utils';

export default {
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);

        this.s3q2_1_sizeVal = this.$store.getters.survey.section3.q2_1_size;
        this.s3q2_1_sizeDescription = this.$store.getters.survey.section3.q2_1_size;
        if (
            this.s3q2_1_sizeVal !== '3MM' &&
            this.s3q2_1_sizeVal !== '6MM' &&
            this.s3q2_1_sizeVal !== '12MM' &&
            this.s3q2_1_sizeVal
        ) {
            this.s3q2_1_sizeVal = 'INNA';
            this.showValueInput = true;
        }

        if (this.$store.getters.survey.section3.q2_1_location) {
            this.refreshCanvas();
        }
    },
    data() {
        return {
            s3q2_1_sizeVal: this.q2_1_size,
            s3q2_1_sizeDescription: this.q2_1_description,
            showValueInput: false,
            windowWidth: document.documentElement.clientWidth,
            canvasWidth: '375px',
            canvasLoaded: false,
        };
    },
    computed: {
        q2_1_size() {
            return this.$store.getters.survey.section3.q2_1_size;
        },
        q2_1_description() {
            return this.$store.getters.survey.section3.q2_1_description;
        },
    },
    methods: {
        // whenever the document is resized, re-set the 'fullHeight' variable
        handleResize(event) {
            this.canvasLoaded = false;
            this.windowWidth = document.documentElement.clientWidth;

            if (this.windowWidth < 520) {
                this.canvasWidth = '175px';
            } else {
                this.canvasWidth = '375px';
            }
            if (this.$store.getters.survey.section3.q2_1_location) {
                this.refreshCanvas();
            }
        },
        updateSize(showValueInput) {
            this.showValueInput = showValueInput;
            if (showValueInput == false) {
                this.$store.commit('STATE_SURVEY', {
                    section3: {
                        ...this.$store.getters.survey.section3,
                        q2_1_size: this.s3q2_1_sizeVal,
                    },
                });
            }
            this.$emit('clicked');
        },
        updateDescription() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q2_1_size: this.s3q2_1_sizeDescription,
                },
            });
        },
        updateCanvas(event) {
            let canvas = document.getElementById('rightBreast');
            let thumbImg = document.createElement('img');
            thumbImg.src = '/src/assets/images/icons/marker.png';

            canvas.onmousedown = function() {
                return false;
            };

            let rect = canvas.getBoundingClientRect();
            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;

            if (browserIsIE11) {
                x += 2;
                y -= 30;
            }

            let ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            thumbImg.onload = () => ctx.drawImage(thumbImg, x, y, 24, 24);

            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q2_1_location: { x: x, y: y },
                },
            });
        },
        updateCanvasFromStore() {
            const x = this.$store.getters.survey.section3.q2_1_location.x;
            const y = this.$store.getters.survey.section3.q2_1_location.y;
            let canvas = document.getElementById('rightBreast');
            let thumbImg = document.createElement('img');
            thumbImg.src = '/src/assets/images/icons/marker.png';
            if (canvas) {
                let ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                thumbImg.onload = () => ctx.drawImage(thumbImg, x, y, 24, 24);
                this.canvasLoaded = true;
            }
        },
        refreshCanvas() {
            this.updateCanvasFromStore();
            setTimeout(() => {
                if (!this.canvasLoaded) {
                    this.refreshCanvas();
                }
            }, 500);
        },
    },
};
</script>



// WEBPACK FOOTER //
// right-breast-changes.vue?af847680